export default {
      id: "pm-logo-usage",
      viewBox: "0 0 234 41",
      url: __webpack_public_path__ + "img/icons.svg#pm-logo",
      toString: function () {
        return this.url;
      }
    }